import { RewardTokens } from './reward';
export const SupportedTokens = {
    ...RewardTokens,
    UTY: 'UTY',
};
//# sourceMappingURL=supported.js.map